<template>
  <div class="template-info-wrapper" :class="{'stop-event': !showInfo}">
    <transition name="template-effect">
      <div class="template-info flex center" v-if="showInfo">
        <div class="button button-template-info center mr-10" @click="validHandler">
          <span class="sprite-round-yes mr-2"/>
          <span class="label">{{validLabel}}</span>
        </div>
        <div class="button button-template-info center" @click="showInfo = false">
          <span class="sprite-round-no mr-2"/>
          <span class="label">annuler</span>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { EventBus, TEMPLATE_FIRST, TEMPLATE_MODIFIED, TEMPLATE_LOADING, TEMPLATE_SAVE } from '@/model/EventBus'
import { defined } from 'junctions-fp'
import { mapGetters } from 'vuex'
export default {
  name: 'TemplateInfo',
  components: {},
  beforeCreate() {},
  async created() {
    this.dictionnary = await this.getLanguages
    EventBus.$on(TEMPLATE_FIRST, () => (this.showInfo = true))
    EventBus.$on(TEMPLATE_LOADING, () => (this.showInfo = false))
    EventBus.$on(TEMPLATE_MODIFIED, () => {
      if (defined(this.currentTemplate)) {
        if(!this.currentTemplate.public){
          this.showInfo = true
          return
        }
        if(this.currentTemplate.public && this.getLimitations.templatePublicCreator){
          this.showInfo = true
          return
        }
        this.showInfo = false
      }
    })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      showInfo: false,
      dictionnary: null
    }
  },
  props: {},
  computed: {
    ...mapGetters(['currentTemplate', 'getLanguages', 'getLimitations']),
    validLabel() {
      if (this.currentTemplate) {
        return this.dictionnary.templateMenu.modifier
      }
      return this.dictionnary.templateMenu.creer
    }
  },
  methods: {
    validHandler() {
      if (this.currentTemplate) {
        EventBus.$emit(TEMPLATE_SAVE)
        return
      }
      this.$emit('createTemplate')
      this.showInfo = false
    }
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/menu/template/TemplateInfo.vue